import styled from 'styled-components/native';

export const Type = styled.Text`
	color: ${({ theme }) => (theme.colors ? theme.font.colors.primary : 'white')};
`;
